export default __webpack_public_path__ + "static/media/safe_deposit_page.2e33d855.pdf";